module.exports = __webpack_public_path__ + "img/logo-menu-sm.46a87cfb.png";